// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Rapports Argent : styles communs (même style que Notifications et B-book) ===== */

.money_report_page {
  --money-report-danger: #B91C1C;
}

[data-theme="dark"] .money_report_page {
  --money-report-danger: #F87171;
}

/* la feuille de style globale supprime tous les outlines : on rend le focus clavier visible */
.money_report_page :is(button, a, select, input):focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.money_report_page .money_report_num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.money_report_page .money_report_num_strong {
  font-weight: 700;
  color: var(--text-primary);
}

.money_report_page .money_report_num_zero {
  color: var(--text-secondary);
  opacity: 0.6;
}

.money_report_page .money_report_date {
  font-weight: 600;
  color: var(--text-primary);
}

/* ----- structure de page ----- */

.money_report_page .money_report_title_row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.money_report_page_title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.money_report_page .money_report_hint {
  margin: 0 0 16px;
  max-width: 75ch;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.money_report_page .money_report_toolbar {
  margin-bottom: 16px;
}

.money_report_page .money_report_card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 24px;
}

/* ----- totaux de la période ----- */

.money_report_page .money_report_summary {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.money_report_page .money_report_tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

.money_report_page .money_report_tile_main {
  background-color: var(--primary-light);
  border-color: color-mix(in srgb, var(--primary) 30%, transparent);
}

.money_report_page .money_report_tile p {
  margin: 0;
}

.money_report_page .money_report_tile_label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

.money_report_page .money_report_tile_value {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.money_report_page .money_report_tile_main .money_report_tile_value {
  color: var(--primary);
}

.money_report_page .money_report_tile_hint {
  font-size: 12px;
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
}

/* ----- tableau : il prend la largeur nécessaire et défile horizontalement au lieu de couper les cellules ----- */

.money_report_page .tableau_container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.money_report_page .tableau_table {
  table-layout: auto;
  width: 100%;
}

.money_report_page .tableau_head_item_th,
.money_report_page .tableau_body_item {
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
}

/* montants alignés à droite, la date reste à gauche */
.money_report_page .tableau_head_item_th:not(:first-child),
.money_report_page .tableau_body_item:not(:first-child) {
  text-align: right;
}

/* ----- boutons ----- */

.money_report_page .money_report_secondary_button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 0 12px;
  border-radius: var(--radius-sm);
  background-color: transparent;
  border: 1px solid var(--border);
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.money_report_page .money_report_secondary_button:hover:not(:disabled) {
  background-color: var(--bg);
  border-color: var(--text-secondary);
}

.money_report_page .money_report_secondary_button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ----- pagination ----- */

.money_report_page .money_report_pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  font-size: 13px;
  color: var(--text-secondary);
}

/* ----- états vide et erreur ----- */

.money_report_page .money_report_empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  text-align: center;
  color: var(--text-secondary);
  border: 1px dashed var(--border);
  border-radius: var(--radius-md);
}

.money_report_page .money_report_empty_title {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary);
}

.money_report_page .money_report_empty_hint {
  margin: 0;
  max-width: 60ch;
  font-size: 13px;
}

.money_report_page .money_report_empty_error {
  color: var(--money-report-danger);
  background-color: var(--danger-light);
  border-style: solid;
  border-color: color-mix(in srgb, var(--money-report-danger) 30%, transparent);
}

.money_report_page .money_report_empty_error .money_report_empty_title {
  color: inherit;
}

/* ----- page d'accueil : une carte par rapport ----- */

.money_report_page .money_report_links {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.money_report_page .money_report_link {
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
  padding: 20px;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  color: var(--text-primary);
  text-decoration: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.money_report_page .money_report_link:hover {
  border-color: var(--primary);
  box-shadow: var(--shadow-md, var(--shadow-sm));
}

.money_report_page .money_report_link_title {
  font-size: 16px;
  font-weight: 700;
}

.money_report_page .money_report_link_title::after {
  content: " →";
  color: var(--primary);
}

.money_report_page .money_report_link_hint {
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-secondary);
}

/* ----- lignes groupées (profits par action : une ligne par période puis ses tickers) ----- */

.money_report_page .money_report_group {
  font-weight: 700;
  color: var(--text-primary);
}

.money_report_page .money_report_ticker {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  background-color: var(--primary-light);
  color: var(--primary);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

@media (prefers-reduced-motion: reduce) {
  .money_report_page * {
    transition-duration: 0.01ms !important;
  }
}

@media (max-width: 768px) {
  .money_report_page .money_report_card {
    padding: 16px;
  }

  .money_report_page .money_report_summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/reports/money/moneyReports.css"],"names":[],"mappings":"AAAA,0FAA0F;;AAE1F;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8FAA8F;AAC9F;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,iEAAiE;AACnE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,kHAAkH;;AAElH;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;;EAEE,iBAAiB;AACnB;;AAEA,wBAAwB;;AAExB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,8FAA8F;;AAE9F;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;AACF","sourcesContent":["/* ===== Rapports Argent : styles communs (même style que Notifications et B-book) ===== */\n\n.money_report_page {\n  --money-report-danger: #B91C1C;\n}\n\n[data-theme=\"dark\"] .money_report_page {\n  --money-report-danger: #F87171;\n}\n\n/* la feuille de style globale supprime tous les outlines : on rend le focus clavier visible */\n.money_report_page :is(button, a, select, input):focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.money_report_page .money_report_num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.money_report_page .money_report_num_strong {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.money_report_page .money_report_num_zero {\n  color: var(--text-secondary);\n  opacity: 0.6;\n}\n\n.money_report_page .money_report_date {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* ----- structure de page ----- */\n\n.money_report_page .money_report_title_row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.money_report_page_title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n}\n\n.money_report_page .money_report_hint {\n  margin: 0 0 16px;\n  max-width: 75ch;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.money_report_page .money_report_toolbar {\n  margin-bottom: 16px;\n}\n\n.money_report_page .money_report_card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n/* ----- totaux de la période ----- */\n\n.money_report_page .money_report_summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.money_report_page .money_report_tile {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n.money_report_page .money_report_tile_main {\n  background-color: var(--primary-light);\n  border-color: color-mix(in srgb, var(--primary) 30%, transparent);\n}\n\n.money_report_page .money_report_tile p {\n  margin: 0;\n}\n\n.money_report_page .money_report_tile_label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.money_report_page .money_report_tile_value {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n}\n\n.money_report_page .money_report_tile_main .money_report_tile_value {\n  color: var(--primary);\n}\n\n.money_report_page .money_report_tile_hint {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ----- tableau : il prend la largeur nécessaire et défile horizontalement au lieu de couper les cellules ----- */\n\n.money_report_page .tableau_container {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.money_report_page .tableau_table {\n  table-layout: auto;\n  width: 100%;\n}\n\n.money_report_page .tableau_head_item_th,\n.money_report_page .tableau_body_item {\n  overflow: visible;\n  text-overflow: clip;\n  white-space: nowrap;\n}\n\n/* montants alignés à droite, la date reste à gauche */\n.money_report_page .tableau_head_item_th:not(:first-child),\n.money_report_page .tableau_body_item:not(:first-child) {\n  text-align: right;\n}\n\n/* ----- boutons ----- */\n\n.money_report_page .money_report_secondary_button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  padding: 0 12px;\n  border-radius: var(--radius-sm);\n  background-color: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.money_report_page .money_report_secondary_button:hover:not(:disabled) {\n  background-color: var(--bg);\n  border-color: var(--text-secondary);\n}\n\n.money_report_page .money_report_secondary_button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ----- pagination ----- */\n\n.money_report_page .money_report_pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* ----- états vide et erreur ----- */\n\n.money_report_page .money_report_empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--text-secondary);\n  border: 1px dashed var(--border);\n  border-radius: var(--radius-md);\n}\n\n.money_report_page .money_report_empty_title {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.money_report_page .money_report_empty_hint {\n  margin: 0;\n  max-width: 60ch;\n  font-size: 13px;\n}\n\n.money_report_page .money_report_empty_error {\n  color: var(--money-report-danger);\n  background-color: var(--danger-light);\n  border-style: solid;\n  border-color: color-mix(in srgb, var(--money-report-danger) 30%, transparent);\n}\n\n.money_report_page .money_report_empty_error .money_report_empty_title {\n  color: inherit;\n}\n\n/* ----- page d'accueil : une carte par rapport ----- */\n\n.money_report_page .money_report_links {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.money_report_page .money_report_link {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  height: 100%;\n  padding: 20px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  color: var(--text-primary);\n  text-decoration: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.money_report_page .money_report_link:hover {\n  border-color: var(--primary);\n  box-shadow: var(--shadow-md, var(--shadow-sm));\n}\n\n.money_report_page .money_report_link_title {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.money_report_page .money_report_link_title::after {\n  content: \" →\";\n  color: var(--primary);\n}\n\n.money_report_page .money_report_link_hint {\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n/* ----- lignes groupées (profits par action : une ligne par période puis ses tickers) ----- */\n\n.money_report_page .money_report_group {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.money_report_page .money_report_ticker {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background-color: var(--primary-light);\n  color: var(--primary);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .money_report_page * {\n    transition-duration: 0.01ms !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .money_report_page .money_report_card {\n    padding: 16px;\n  }\n\n  .money_report_page .money_report_summary {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
